import { AppMode } from '@/models/app'

function getAppModeFromHost(url: URL): AppMode {
  const { host } = url

  if (host.startsWith('app.') || host.startsWith('new-app.')) {
    return AppMode.APP
  }

  if (host.startsWith('booking.') || host.startsWith('new-booking.')) {
    return AppMode.WEBSITE
  }

  if (host.startsWith('kiosk.') || host.startsWith('new-kiosk.')) {
    return AppMode.KIOSK
  }

  if (host.startsWith('widget.') || host.startsWith('new-widget.')) {
    return AppMode.WIDGET
  }

  return AppMode.WIDGET
}

type ChannelAndModeResolution = {
  channel: string
  mode: AppMode
}

// Mirrors the `setupByUrl` logic extracted from store/appSlice, that sets `channel` and `mode`
// Returns `null` when the reducer left those fields unchanged (no `ch` query param and host is app)
export function resolveChannelAndModeFromUrl(
  href: string
): ChannelAndModeResolution | null {
  const url = new URL(href)
  const searchParamChannel = url.searchParams.get('ch')
  const appMode = getAppModeFromHost(url)

  if (searchParamChannel === 'yb') {
    return { channel: 'yb', mode: AppMode.WEBSITE }
  }
  if (searchParamChannel === 'app-yb') {
    return { channel: 'app-yb', mode: AppMode.APP }
  }
  if (searchParamChannel === 'kiosk') {
    return { channel: 'kiosk', mode: AppMode.KIOSK }
  }
  if (!searchParamChannel) {
    if (appMode === AppMode.WEBSITE) {
      return { channel: 'yb', mode: AppMode.WEBSITE }
    }
    if (appMode === AppMode.WIDGET) {
      return { channel: 'widget', mode: AppMode.WIDGET }
    }
    if (appMode === AppMode.KIOSK) {
      return { channel: 'kiosk', mode: AppMode.KIOSK }
    }
    return null
  }
  if (appMode === AppMode.WEBSITE) {
    return { channel: 'yb', mode: AppMode.WEBSITE }
  }
  return { channel: searchParamChannel, mode: appMode }
}
